module.exports = __webpack_public_path__ + "img/Zizbey-logo-H-35.819b29ed.svg";